<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ formData.title }}</h2>
                </v-row>

                <v-container id="scroll-target" class="overflow-y-auto px-5">
                    <v-card>
                        <div class="ma-4">
                            <v-subheader class="blue--text">{{$t('reportsparam.parameters')}}</v-subheader>
                            <v-row class="mb-n12">
                                <v-col cols="8" sm="8" class="pb-n5 ">
                                    <v-autocomplete
                                    outlined
                                    :label="this.$t('performancereport.reviewexercisedescription')"
                                    type="text"
                                    :rules="[rules.required]"
                                    :items="reviewExerciseList"
                                    v-model="formData.reviewexerciseid"
                                    @change="changeReviewExercise(formData.reviewexerciseid)"
                                    dense
                                    ></v-autocomplete>                    
                                </v-col>
                                <v-col cols="4" sm="4" class="pb-n5 mt-1">
                                    <v-text-field
                                    outlined
                                    :label="this.$t('pmassementrecord.reviewexercisecode')"
                                    type="text"
                                    v-model="formData.reviewexercisecode"
                                    readonly
                                    background-color="#ffeab2"
                                    dense
                                ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4" sm="4" class="pb-n5">
                                    <v-autocomplete
                                    outlined
                                    :label="this.$t('reviewenquiryanalysis.viewby')"
                                    type="text"
                                    v-model="formData.viewby"
                                    :items="viewby"
                                    dense
                                ></v-autocomplete>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                </v-container>

                <v-row>
                    <div class="pt-5 pl-6 pb-4">
                        <v-row>
                            <v-col>
                                <v-btn 
                                    color="warning" 
                                    style="width: 100px"
                                    @click="goHandler" 
                                > 
                                {{$t('button.go')}}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-row>
            </v-form>
        </v-container>
    </div>
</template>

<script>
export default {
    props: {
        parentObject: Object
    },

    data() {
        return{
            rules: {
                required: (value) => !!value || this.$t('reportsparam.required'),
            },

            formData:{
                reviewexerciseid: null,
                reviewexercisecode: null,
                reviewexercisename: null,
                viewby: null,
                title: this.parentObject.pageTitle,
            },

            viewby: [
                { text: this.$t('columns.company'), value: 'Company' },
                { text: this.$t('columns.department'), value: 'Department' },
                { text: this.$t('columns.branch'), value: 'Branch' },
                { text: this.$t('columns.section'), value: 'Section' },
            ],

            reviewExerciseList: [],
            isErr: false,
            errMsg: "",

            activeStaff: true,
        }
    },

    methods: {
        goHandler() {
            this.$router.push({name: 'reviewenquirydetailsanalysis', params: { reviewexerciseid: this.formData.reviewexerciseid, reviewexercisename: this.formData.reviewexercisename, viewby: this.formData.viewby} });

        },

        changeReviewExercise(id) {
            let item = this.reviewExerciseList.find((item) => item.id == id);
            this.formData.reviewexercisecode = item.reviewexercisecode;
            this.formData.reviewexercisename = item.description;
        },

        loadReviewExerciseHandler() {
            const vm = this;

            this.$store.dispatch('get', {url: "/reviewexercise/all"})
            .then((res) => {

            for (let i = 0; i < res.data.rec.length; i++) {
                
                vm.reviewExerciseList.push({
                text: res.data.rec[i].description,
                value: res.data.rec[i].id,
                reviewexercisecode: res.data.rec[i].reviewcode,
                ...res.data.rec[i], // Add the rest of the properties from res.data.rec[i]
                });
            }

            })
            .catch((err) => {
            vm.isErr = true;
            vm.errMsg = err;
            });
        },
    },

    mounted(){
        this.loadReviewExerciseHandler();
    },

}
</script>